/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import ImportExport from './import-export.service';
import ImportDialogController from './import-dialog.controller';

export default angular.module('tektelic.importexport', [])
    .factory('importExport', ImportExport)
    .controller('ImportDialogController', ImportDialogController)
    .name;



// WEBPACK FOOTER //
// ./src/app/import-export/index.js